/* ============================================================
 * Page transition — fade overlay on internal link clicks.
 * Opt-in via settings (default OFF). Respects prefers-reduced-motion.
 * Uses sessionStorage to hand off the transition state between pages,
 * so the overlay covers the browser's native blank gap during navigation.
 * ============================================================ */

(function () {
  const overlay = document.getElementById('page-transition-overlay');
  if (!overlay) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const DURATION = parseInt(overlay.dataset.duration, 10) || 400;
  const HANDOFF_KEY = 'lion-page-transition';

  function setShown() {
    overlay.style.transition = 'none';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    // Force reflow so the next transition is applied
    void overlay.offsetWidth;
  }

  function fadeIn() {
    overlay.style.transition = `opacity ${DURATION}ms ease`;
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
  }

  function fadeOut() {
    overlay.style.transition = `opacity ${DURATION}ms ease`;
    overlay.style.opacity = '0';
    overlay.style.pointerEvents = 'none';
  }

  // Inbound: if we arrived through a transition, start with the overlay shown
  // and fade it out once the page is interactive.
  function handleInbound() {
    let inbound = false;
    try { inbound = sessionStorage.getItem(HANDOFF_KEY) === '1'; } catch (_) {}
    try { sessionStorage.removeItem(HANDOFF_KEY); } catch (_) {}
    if (!inbound) return;
    setShown();
    requestAnimationFrame(() => requestAnimationFrame(fadeOut));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInbound);
  } else {
    handleInbound();
  }

  // bfcache restore: ensure overlay isn't stuck shown after going back.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) fadeOut();
  });

  let navTimeout = null;

  document.addEventListener('click', (e) => {
    // Cooperate with JS-driven links. Element-level listeners (collection
    // load-more / filter-clear, search toggles, etc.) bubble to this document
    // listener AFTER running, so if one already called preventDefault() the
    // click is being handled in-page — don't hijack it into a full navigation.
    if (e.defaultPrevented) return;
    const link = e.target.closest('a');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;
    if (
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:') ||
      link.hasAttribute('download') ||
      link.target === '_blank' ||
      e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0
    ) return;
    let url;
    try { url = new URL(href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    // Same-page anchor — skip
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

    e.preventDefault();
    if (navTimeout) clearTimeout(navTimeout);
    try { sessionStorage.setItem(HANDOFF_KEY, '1'); } catch (_) {}
    fadeIn();
    navTimeout = setTimeout(() => {
      navTimeout = null;
      window.location.assign(href);
    }, DURATION);
  });
})();
